import { Environment } from "@core/domains/interfaces/environment.interface";

export const environment: Environment = {
  production: false,
  apiURL: 'https://demo.api.gymo.paullence.link/api/v1',
  // apiURL: 'http://localhost:8000/api/v1',
  endPoint: {} as any,
  firebaseConfig: {
    apiKey: "AIzaSyD7AyLpQwKeC0qaqxdeef2zDYRgEYQRBxc",
    authDomain: "gymo-b7e68.firebaseapp.com",
    projectId: "gymo-b7e68",
    storageBucket: "gymo-b7e68.firebasestorage.app",
    messagingSenderId: "145365763501",
    appId: "1:145365763501:web:3e87d4c28de193fcd44d24",
    measurementId: "G-J2XLE6XE7E"
  },
  firebaseVapidKey:'BPN4Cl5u3sXJfR9EaQrRWteuSPwiPprokLfvv-IsR8NAmgH4eC4OReRtgR4TWxd9ESUQdEdYSdieQQYkZKTfrU0',
};

environment.endPoint = {
  // auth
  login: 'auth/login/',
  refreshToken: 'auth/refresh-token/',
  requestResetPassword: 'auth/request-reset-password/',
  resentOtp: 'auth/resent-otp/',
  verifyOtp: 'auth/verify-otp/',
  resetPassword: 'auth/reset-password/',
  updatePassword: 'update-password/',
  me: 'profile/',

  // Gym
  getTypeGymAdmin: 'admin/type-gym/',
  getTypeGym: 'type-gym/',
  postTypeGym: 'admin/type-gym/',
  putTypeGym: 'admin/type-gym/',
  deleteTypeGym: 'admin/type-gym/',

  // Member of Gymo
  getMemberShip: 'membership/',
  postMemberShip: 'membership/',
  updateMemberShipStatus: 'admin/membership',
  getMemberShipDetail: (slug: string) => `membership/${slug}`,
  blockOrUnblockMemberShip: (slug: string, action: 'disable'|'enable') => `membership/${slug}/${action}/`,
  validateMembership: (id: string, request_status: string) => `membership/validate/${id}/${request_status}/`,
  postCoachMembership: 'membership/coach/',
  validateCoachMembership: (id: string | number, request_status: string) => `membership/coach/${id}/${request_status}/`,

  // stats
  getMemberShipStats: 'stats/memberships/clubs/',
  getClubMembershipStats: 'stats/memberships/clubs/',
  getCoachMembershipStats: 'stats/memberships/coaches/',
  getAdminDashboardStats: 'stats/dashboard/admin/',
  getStatsCustomers: (clubId: number) => `stats/customers/${clubId}/`,
  getStatsDashboard: (clubId: number) => `stats/dashboard/${clubId}/`,
  getCoachDashboardStats: (clubId: number) => `stats/coach/dashboard/${clubId}/`,
  getCoachPackagesStats: (clubId: number | string) => `stats/packages/${clubId}/`,
  getCoachCustomersStats: (coachId: number | string) => `stats/coach/customers/${coachId}/`,
  getStatsEquipments: (clubId: number) => `stats/equipments/${clubId}/`,
  getStatsWorkers: (clubId: number) => `stats/workers/${clubId}/`,


  // Packages (abonnements)
  getPackages: (clubId: any) => `packages/${clubId}/`,
  getAllPackages: (clubId: any) => `packages/${clubId}/all/`,
  getAbonnements: (clubId: any) => `abonnements/${clubId}/`,
  createPackage: (clubId: any) => `package/create/${clubId}/`,
  updatePackage: (id: any) => `package/${id}/`,
  deletePackage: (id: any) => `package/${id}/`,

  // Club (POST /club/ est désactivé côté backend)
  // createClub: 'club/',
  getClubs: 'clubs/',
  updateClub: (slug: string) => `club/${slug}/`,
  hasAddress: (clubId: number | string) => `club/${clubId}/has-address/`,
  assignByCode: (clubId: number | string) => `club/${clubId}/assign/`,

  // Customers
  getCustomers: (clubId: number) => `customers/${clubId}/`,
  createCustomer: 'customer/',
  createCustomerSession: 'customer/session/',
  updateCustomer: (id: any) => `customer/${id}/`,
  renewSubscription: (customerId: any, clubId: any) => `abonnement/${customerId}/${clubId}/renew`,
  newCustomerSession: (customerId: any, clubId: any) => `session/${customerId}/${clubId}/new`,
  
  // Workers/Employees
  getWorkers: (clubId: number) => `workers/${clubId}/`,
  createWorker: (clubId: number) => `worker/create/${clubId}/`,
  updateWorker: (id: any) => `worker/${id}/`,

  // Equipments
  getEquipments: (clubId: number) => `equipments/${clubId}/`,
  createEquipment: (clubId: number) => `equipment/create/${clubId}/`,
  updateEquipment: (id: number) => `equipment/${id}/`,
  deleteEquipment: (id: any) => `equipment/${id}/`,

  // Sessions / Seances
  getSessions: (clubId: number | string) => `sessions/${clubId}/`,
  getAllSessions: (clubId: number | string) => `sessions/${clubId}/all/`,
  createSession: (clubId: number | string) => `session/create/${clubId}/`,
  updateSession: (id: number | string) => `session/${id}/`,

  // FCM
  sendToken: 'device/',
  disable: 'device',

  // Coach Freelance
  coachMe: 'coach/me/',
  coachPackages: 'coach/packages/',
  coachPackagesAll: 'coach/packages/all/',
  coachPackage: (id: any) => `coach/package/${id}/`,
  coachSessions: 'coach/sessions/',
  coachSessionsAll: 'coach/sessions/all/',
  coachSession: (id: any) => `coach/session/${id}/`,
  coachSessionComplete: (id: any) => `coach/session/${id}/complete/`,
  coachSessionNewCustomer: (customerId: any) => `coach/session/${customerId}/new`,
  coachCustomers: 'coach/customers/',
  coachCustomersAll: 'coach/customers/all/',
  coachCustomer: (id: any) => `coach/customer/${id}/`,

  // Suggestions
  getSuggestions: 'suggestions/',
  createSuggestion: 'suggestion/',
  updateSuggestionStatus: (id: any) => `suggestion/${id}/status/`,

  // Notifications
  getNotifications: 'notifications/',
  markNotificationRead: (id: any) => `notification/${id}/read/`,
  markAllNotificationsRead: 'notifications/read-all/',
}
